// Texts for world 'ocean': name on the map and the level titles, per language.
// The ids must be the level ids in levels.ts (npm run validate checks this); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Havdisko',
    levels: {
      'sink': { title: 'Synk' },
      'bubbles': { title: 'Bobler' },
      'current': { title: 'Strømmen' },
      'bubble-balloon': { title: 'Bobleballon' },
      'float': { title: 'Flyderen' },
      'countercurrent': { title: 'Modstrøm' },
      'jellyfish': { title: 'Vandmanden' },
      'bubble-pump': { title: 'Boblepumpen' },
      'empty-the-float': { title: 'Tøm flyderen' },
      'bubble-and-current': { title: 'Boble og strøm' },
      'steer-the-balloon': { title: 'Styr ballonen' },
      'hop-and-bubbles': { title: 'Hop og bobler' },
      'float-and-current': { title: 'Flyder og strøm' },
      'balloon-journey': { title: 'Ballonrejsen' },
      'master': { title: 'Mester' },
    },
    scene: { disco: 'DISKO!' },
  },
  en: {
    name: 'Ocean disco',
    levels: {
      'sink': { title: 'Sink' },
      'bubbles': { title: 'Bubbles' },
      'current': { title: 'The current' },
      'bubble-balloon': { title: 'Bubble balloon' },
      'float': { title: 'The float' },
      'countercurrent': { title: 'Against the current' },
      'jellyfish': { title: 'The jellyfish' },
      'bubble-pump': { title: 'The bubble pump' },
      'empty-the-float': { title: 'Empty the float' },
      'bubble-and-current': { title: 'Bubble and current' },
      'steer-the-balloon': { title: 'Steer the balloon' },
      'hop-and-bubbles': { title: 'Hop and bubbles' },
      'float-and-current': { title: 'Float and current' },
      'balloon-journey': { title: 'The balloon journey' },
      'master': { title: 'Master' },
    },
    scene: { disco: 'DISCO!' },
  },
});
